/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoDayPicker {
    restrict = "E";
    scope = {
      name: "@",
      ngModel: "=ngModel",
      disabled: "=ngDisabled",
      month: "=month",
      year: "=year",  
      required: "=ngRequired",
      tabIndex: "=?",
      invalid: "=isInvalid",
      onDayValidityChange: "&?"
    };
    
    require = "ngModel";

    templateUrl = "app/components/controls/dayPickerTemplate.html";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        scope.resolvedDayText = this.$translate.instant("LABEL_DAY");
        scope.getDayNumbers = function (month: number = 1, year: number = 2000): number[] {
            var noOfDays = new Date(year || 2000, month, 0).getDate();
            var numbers = new Array<number>(noOfDays);
            for (var i = 0; i < noOfDays; i++) {
                numbers[i] = i + 1;
            }
            if (scope.ngModel && scope.ngModel > noOfDays) {
                numbers.push(scope.ngModel);
            }
            return numbers;
        };

        scope.onDaySelected = function() {
           ngModel.$setViewValue(scope.ngModel);
        };

        scope.$watch(
            () => `${scope.month}_${scope.year}_${scope.ngModel}`,
            () => {
                if (!scope.month || !scope.ngModel) {
                    if (scope.onDayValidityChange) {
                        scope.onDayValidityChange({ $isInvalid: false });
                    }
                    return;
                }
                const year = scope.year || 2000;
                const maxDay = new Date(year, scope.month, 0).getDate();
                const isInvalid = scope.ngModel > maxDay;
              /** We can prevent users from saving invalid dates — they will see red borders around
               * each field if the date is invalid. To achieve this, we should add #year to the date picker
               * and #is-invalid to the other fields.**/
              if (scope.onDayValidityChange) {
                    scope.onDayValidityChange({ $isInvalid: isInvalid });
                }
            }
        );
    }

    constructor(private $translate: angular.translate.ITranslateService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($translate) => {
        return new MeevoDayPicker($translate);
      };

      directive.$inject = ["$translate"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoDayPicker", MeevoDayPicker.factory());

}